import React from 'react';
import { connect } from 'react-redux';
import Form from '../../FormsTemplate';
import { FormNames } from '../../Forms.constants';

import UserInfoSection from '../../Sections/UserInfoSection/UserInfoSection';
import ManufacturerModelSection from '../../Sections/ManufacturerModelSection/ManufacturerModelSection';
import DeviceTypesSection from '../../Sections/DeviceTypesSection/DeviceTypesSection';
import HMISection from '../../Sections/HMISection/HMISection';
import VisualInspectSection from '../../Sections/VisualInspectSection/VisualInspectSection';
import TestResultSection from '../../Sections/TestResultSection/TestResultSection';
import AsLeftTestTableSection from '../../Sections/AsLeftTestTableSection/AsLeftTestTableSection';
import FoundResultSection from '../../Sections/FoundResultSection/FoundResultSection';
import AsFoundTestTableSection from '../../Sections/AsFoundTestTableSection/AsFoundTestTableSection';
import NoteSection from '../../Sections/NoteSection/NoteSection';
import MagneticFloatCheckSection from '../../Sections/MagneticFloatCheck/MagneticFloatCheck';
import FoundThresholdSection from '../../Sections/FoundThresholdSection/FoundThresholdSection';
import Diagnostics from '../../Sections/Diagnostics/Diagnostics';
import FailureModeSection from '../../Sections/FailureModeSection/FailureModeSection';
import BorderedBox from '../../BorderedBox';
import ToleranceInstrumentEUComment from '../../Sections/ToleranceInstrumentEUComment/ToleranceInstrumentEUComment';
import SetpointSection from '../../Sections/SetpointSection/SetpointSection';
import TestResultComponent from '../../Sections/TestResultComponent/TestResultComponent';
import FlowChangeCheckSection from '../../Sections/FlowChangeCheck/FlowChangeCheckSection';

const P78Form = (props) => (
    <Form
        formName={FormNames.P78}
    >
        <UserInfoSection />
        <ManufacturerModelSection />
        <DeviceTypesSection />
        <HMISection />
        <VisualInspectSection />
        <MagneticFloatCheckSection />
        <Diagnostics />
        <FailureModeSection />
        <BorderedBox>
            <FlowChangeCheckSection />
        </BorderedBox>
        <BorderedBox>
            <AsFoundTestTableSection />
            <FoundResultSection />
        </BorderedBox>
        <ToleranceInstrumentEUComment />
        <FoundThresholdSection />
        <BorderedBox>
            <AsLeftTestTableSection />
        </BorderedBox>
        <BorderedBox>
            <SetpointSection />
        </BorderedBox>
        <TestResultSection />
        <TestResultComponent />
        <NoteSection />
    </Form>
);

const mapStateToProps = ({ Forms }) => ({
    selectedTag: Forms.selectedTag,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P78Form);
